type AnyObject = { [key: string]: any }

function isObject(value: any): value is AnyObject {
  return value !== null && typeof value === 'object' && !Array.isArray(value)
}

function deepOmit(
  obj: AnyObject | any[],
  keysToOmit: string | string[]
): AnyObject | any[] {
  const keys = Array.isArray(keysToOmit) ? keysToOmit : [keysToOmit]

  function omitDeep(value: any): any {
    if (isObject(value)) {
      const result: AnyObject = {}
      for (const key in value) {
        if (keys.includes(key)) {
          continue
        }
        result[key] = omitDeep(value[key])
      }
      return result
    }
    if (Array.isArray(value)) {
      return value.map(omitDeep)
    }
    return value
  }

  return omitDeep(obj)
}

export default deepOmit
